import Axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL;

export default (accessToken, getNewAccessToken) => {
    let api = Axios.create({
        baseURL
    });

    api.interceptors.response.use(undefined, error => {
        if (error.response && error.response.status === 401 && error.config && !error.config._retry) {
            return Promise.resolve(getNewAccessToken).then(({ accessToken }) => {
                error.config._retry = true;
                error.config.headers.Authorization = accessToken;

                return api(error.config);
            });
        }

        return Promise.reject(error);
    });

    api.interceptors.request.use(config => {
        if (!config.headers.common['Authorization']) {
            config.headers.common['Authorization'] = accessToken;
        }

        return config;
    });

    return api;
};



// WEBPACK FOOTER //
// ./src/lib/er-axios.js